import React from 'react';
import PropTypes from 'prop-types';

import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/system';

import { withQueryString } from 'helpers/apiHelpers';
import { ITEM_DESCRIPTION_AND_PRICES } from 'styles/constants/appearanceSectionNames';

const StyledLink = styled(Link)({
  color: 'inherit',
  textDecoration: 'underline',
  fontWeight: 600,
  cursor: 'pointer'
});

const SpecialOrderInquiryMsg = ({
  isSoldOut,
  mailTo,
  itemName,
  restaurantName,
  locationName,
  inventoryLessCart
}) => {
  const styles = { variant: ITEM_DESCRIPTION_AND_PRICES };
  const limitedQtyMsg = `Sorry, we have a limited quantity. To add more than ${inventoryLessCart},`;

  const endpoint = `mailto:${mailTo}`;
  const queryParams = {
    subject: `Special Order / ${itemName} Inquiry at ${restaurantName} - ${locationName}`
  };
  const href = withQueryString(endpoint, queryParams);

  const emailLinkComponent = (
    <StyledLink
      data-testid="special-order-inquiry-email-link"
      href={href}
      aria-label={`Email ${mailTo} to inquire about a special order for ${itemName}`}
    >
      {mailTo}
    </StyledLink>
  );

  // if not isSoldOut, then must be inventoryIsDepletedWithCurrentQuantity
  const emailText = isSoldOut ? 'Email' : `${limitedQtyMsg} email`;

  return (
    <Typography {...styles}>
      {emailText} {emailLinkComponent} to inquire about a special order.
    </Typography>
  );
};

SpecialOrderInquiryMsg.propTypes = {
  isSoldOut: PropTypes.bool.isRequired,
  mailTo: PropTypes.string.isRequired,
  itemName: PropTypes.string.isRequired,
  restaurantName: PropTypes.string.isRequired,
  locationName: PropTypes.string.isRequired,
  inventoryLessCart: PropTypes.number.isRequired
};

export default SpecialOrderInquiryMsg;
